module.exports = __webpack_public_path__ + "img/bank-line-trans.fcc5b3b8.svg";